import React from 'react';
import { Link } from 'react-router-dom';
import { PackageIcon, MessageSquareIcon, SearchIcon, ShieldCheckIcon, TruckIcon, BarChartIcon, CheckCircleIcon } from 'lucide-react';
export function HomePage() {
  return <div className="bg-white w-full" data-id="element-171">
      {/* Hero Section */}
      <header className="bg-gradient-to-r from-red-600 to-blue-700" data-id="element-172">
        <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-173">
          <div className="flex justify-between h-16 items-center" data-id="element-174">
            <div className="flex items-center" data-id="element-175">
              <div className="bg-white p-2 rounded-lg shadow-md" data-id="element-176">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9YiZ8fYR9MF9BFf8vhx3gU/Kastom_Printing_Logo.png" alt="Kastom Printing Logo" className="h-16 w-auto" data-id="element-177" />
              </div>
              <span className="ml-2 text-xl font-bold text-white sr-only" data-id="element-178">
                Kastom Printing
              </span>
            </div>
            <div className="hidden md:block" data-id="element-179">
              <div className="ml-10 flex items-center space-x-4" data-id="element-180">
                <Link to="/login" className="text-white hover:bg-red-700 px-3 py-2 rounded-md text-sm font-medium" data-id="element-181">
                  Log in
                </Link>
                <Link to="/register" className="bg-white text-red-600 hover:bg-red-50 px-4 py-2 rounded-md text-sm font-medium" data-id="element-182">
                  Sign up
                </Link>
              </div>
            </div>
          </div>
        </nav>
        <div className="max-w-7xl mx-auto py-16 px-4 sm:py-24 sm:px-6 lg:px-8 text-center" data-id="element-183">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl md:text-6xl" data-id="element-184">
            <span className="block" data-id="element-185">Packaging Solutions</span>
            <span className="block" data-id="element-186">Made Simple</span>
          </h1>
          <p className="mt-6 max-w-lg mx-auto text-xl text-red-100 sm:max-w-3xl" data-id="element-187">
            Connect directly with packaging suppliers, streamline your sourcing
            process, and find the perfect packaging solutions for your business.
          </p>
          <div className="mt-10 max-w-sm mx-auto sm:max-w-none sm:flex sm:justify-center" data-id="element-188">
            <div className="space-y-4 sm:space-y-0 sm:mx-auto sm:inline-grid sm:grid-cols-2 sm:gap-5" data-id="element-189">
              <Link to="/register?role=buyer" className="flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-red-700 bg-white hover:bg-red-50 sm:px-8" data-id="element-190">
                I Need Packaging
              </Link>
              <Link to="/register?role=supplier" className="flex items-center justify-center px-4 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-black bg-opacity-60 hover:bg-opacity-70 sm:px-8" data-id="element-191">
                I Supply Packaging
              </Link>
            </div>
          </div>
        </div>
      </header>
      {/* Features Section */}
      <div className="py-12 bg-white" data-id="element-192">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-193">
          <div className="lg:text-center" data-id="element-194">
            <h2 className="text-base text-red-600 font-semibold tracking-wide uppercase" data-id="element-195">
              Features
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl" data-id="element-196">
              A better way to source packaging
            </p>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto" data-id="element-197">
              Our platform connects packaging buyers with qualified suppliers to
              streamline the entire sourcing process.
            </p>
          </div>
          <div className="mt-10" data-id="element-198">
            <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-2 md:gap-x-8 md:gap-y-10" data-id="element-199">
              <div className="flex" data-id="element-200">
                <div className="flex-shrink-0" data-id="element-201">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-red-500 text-white" data-id="element-202">
                    <SearchIcon className="h-6 w-6" data-id="element-203" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-204">
                  <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-205">
                    Find the right suppliers
                  </h3>
                  <p className="mt-2 text-base text-gray-500" data-id="element-206">
                    Easily search and filter through our network of verified
                    packaging suppliers to find the perfect match for your
                    needs.
                  </p>
                </div>
              </div>
              <div className="flex" data-id="element-207">
                <div className="flex-shrink-0" data-id="element-208">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-red-500 text-white" data-id="element-209">
                    <MessageSquareIcon className="h-6 w-6" data-id="element-210" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-211">
                  <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-212">
                    Direct communication
                  </h3>
                  <p className="mt-2 text-base text-gray-500" data-id="element-213">
                    Chat directly with suppliers to discuss your specific
                    requirements, request quotes, and negotiate terms.
                  </p>
                </div>
              </div>
              <div className="flex" data-id="element-214">
                <div className="flex-shrink-0" data-id="element-215">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-red-500 text-white" data-id="element-216">
                    <ShieldCheckIcon className="h-6 w-6" data-id="element-217" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-218">
                  <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-219">
                    Verified suppliers
                  </h3>
                  <p className="mt-2 text-base text-gray-500" data-id="element-220">
                    All suppliers on our platform undergo a thorough
                    verification process to ensure quality and reliability.
                  </p>
                </div>
              </div>
              <div className="flex" data-id="element-221">
                <div className="flex-shrink-0" data-id="element-222">
                  <div className="flex items-center justify-center h-12 w-12 rounded-md bg-red-500 text-white" data-id="element-223">
                    <TruckIcon className="h-6 w-6" data-id="element-224" />
                  </div>
                </div>
                <div className="ml-4" data-id="element-225">
                  <h3 className="text-lg leading-6 font-medium text-gray-900" data-id="element-226">
                    Streamlined logistics
                  </h3>
                  <p className="mt-2 text-base text-gray-500" data-id="element-227">
                    Track orders, manage deliveries, and coordinate logistics
                    all in one place for a seamless experience.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* How It Works Section */}
      <div className="bg-gray-50 py-12" data-id="element-228">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-229">
          <div className="lg:text-center" data-id="element-230">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase" data-id="element-231">
              How it works
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl" data-id="element-232">
              Simple, transparent process
            </p>
            <p className="mt-4 max-w-2xl text-xl text-gray-500 lg:mx-auto" data-id="element-233">
              Our platform makes finding and sourcing packaging materials easier
              than ever before.
            </p>
          </div>
          <div className="mt-10" data-id="element-234">
            <div className="space-y-10 md:space-y-0 md:grid md:grid-cols-3 md:gap-x-8 md:gap-y-10" data-id="element-235">
              <div className="text-center" data-id="element-236">
                <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-500 text-white mx-auto" data-id="element-237">
                  <span className="text-lg font-bold" data-id="element-238">1</span>
                </div>
                <h3 className="mt-4 text-lg leading-6 font-medium text-gray-900" data-id="element-239">
                  Create an account
                </h3>
                <p className="mt-2 text-base text-gray-500" data-id="element-240">
                  Sign up as a buyer or supplier and complete your profile with
                  your specific requirements or offerings.
                </p>
              </div>
              <div className="text-center" data-id="element-241">
                <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-500 text-white mx-auto" data-id="element-242">
                  <span className="text-lg font-bold" data-id="element-243">2</span>
                </div>
                <h3 className="mt-4 text-lg leading-6 font-medium text-gray-900" data-id="element-244">
                  Connect and discuss
                </h3>
                <p className="mt-2 text-base text-gray-500" data-id="element-245">
                  Browse products or receive inquiries, and communicate directly
                  to discuss specifications and requirements.
                </p>
              </div>
              <div className="text-center" data-id="element-246">
                <div className="flex items-center justify-center h-12 w-12 rounded-full bg-blue-500 text-white mx-auto" data-id="element-247">
                  <span className="text-lg font-bold" data-id="element-248">3</span>
                </div>
                <h3 className="mt-4 text-lg leading-6 font-medium text-gray-900" data-id="element-249">
                  Order and deliver
                </h3>
                <p className="mt-2 text-base text-gray-500" data-id="element-250">
                  Place orders, track shipments, and manage your packaging
                  supply chain all through our platform.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Testimonials */}
      <div className="bg-white py-12" data-id="element-251">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-252">
          <div className="lg:text-center" data-id="element-253">
            <h2 className="text-base text-blue-600 font-semibold tracking-wide uppercase" data-id="element-254">
              Testimonials
            </h2>
            <p className="mt-2 text-3xl leading-8 font-extrabold tracking-tight text-gray-900 sm:text-4xl" data-id="element-255">
              Trusted by businesses worldwide
            </p>
          </div>
          <div className="mt-10 grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3" data-id="element-256">
            <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-257">
              <div className="flex items-center mb-4" data-id="element-258">
                <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-259">
                  <span className="text-blue-600 font-bold" data-id="element-260">A</span>
                </div>
                <div className="ml-4" data-id="element-261">
                  <h4 className="text-lg font-medium text-gray-900" data-id="element-262">
                    Alex Johnson
                  </h4>
                  <p className="text-gray-500" data-id="element-263">Food Products Inc.</p>
                </div>
              </div>
              <p className="text-gray-600" data-id="element-264">
                "Kastom Printing has transformed our packaging sourcing process.
                We've reduced our procurement time by 60% and found higher
                quality suppliers."
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-265">
              <div className="flex items-center mb-4" data-id="element-266">
                <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-267">
                  <span className="text-blue-600 font-bold" data-id="element-268">S</span>
                </div>
                <div className="ml-4" data-id="element-269">
                  <h4 className="text-lg font-medium text-gray-900" data-id="element-270">
                    Sarah Williams
                  </h4>
                  <p className="text-gray-500" data-id="element-271">Eco Packaging Solutions</p>
                </div>
              </div>
              <p className="text-gray-600" data-id="element-272">
                "As a sustainable packaging supplier, this platform has helped
                us connect with businesses that value our eco-friendly options.
                Our customer base has grown by 40%."
              </p>
            </div>
            <div className="bg-gray-50 p-6 rounded-lg shadow-sm" data-id="element-273">
              <div className="flex items-center mb-4" data-id="element-274">
                <div className="h-10 w-10 rounded-full bg-blue-100 flex items-center justify-center" data-id="element-275">
                  <span className="text-blue-600 font-bold" data-id="element-276">M</span>
                </div>
                <div className="ml-4" data-id="element-277">
                  <h4 className="text-lg font-medium text-gray-900" data-id="element-278">
                    Michael Chen
                  </h4>
                  <p className="text-gray-500" data-id="element-279">Global Shipping Co.</p>
                </div>
              </div>
              <p className="text-gray-600" data-id="element-280">
                "The direct communication with suppliers has eliminated
                misunderstandings and improved our packaging specifications.
                Highly recommended!"
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* CTA Section */}
      <div className="bg-blue-600" data-id="element-281">
        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8 lg:flex lg:items-center lg:justify-between" data-id="element-282">
          <h2 className="text-3xl font-extrabold tracking-tight text-white sm:text-4xl" data-id="element-283">
            <span className="block" data-id="element-284">
              Ready to streamline your packaging process?
            </span>
            <span className="block text-blue-100" data-id="element-285">
              Join our platform today.
            </span>
          </h2>
          <div className="mt-8 flex lg:mt-0 lg:flex-shrink-0" data-id="element-286">
            <div className="inline-flex rounded-md shadow" data-id="element-287">
              <Link to="/register" className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-blue-600 bg-white hover:bg-blue-50" data-id="element-288">
                Get started
              </Link>
            </div>
            <div className="ml-3 inline-flex rounded-md shadow" data-id="element-289">
              <Link to="/contact" className="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-blue-800 hover:bg-blue-700" data-id="element-290">
                Learn more
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>;
}